import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="text-9xl font-bold text-gray-200">404</div>
        <h1 className="mt-4 text-2xl font-bold text-gray-900">
          Pagina no encontrada
        </h1>
        <p className="mt-2 text-gray-600">
          La pagina que buscas no existe o fue movida.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn btn-primary">
            Volver al inicio
          </Link>
          <Link to="/buscar" className="btn btn-secondary">
            Buscar productos
          </Link>
        </div>
      </div>
    </div>
  );
}
